import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { InfoItemDd, InfoItemDt, InfoItemList, Section, SectionSubHeader } from '../../common';
import { CustomerToken } from '../../../types/customers';

interface Props extends WithTranslation {
    tokens?: CustomerToken[];
}

const Tokens = ({ tokens, t }: Props) => {
    if (!tokens || tokens.length === 0) return null;
    return (
        <Section>
            <SectionSubHeader>{t('customers.fields.tokens')}</SectionSubHeader>
            {tokens.map((token) => {
                let val = token.value;
                if (token.metadata) {
                    val += ' | ' + Object.values(token.metadata).join(' | ');
                }
                return (
                    <InfoItemList key={token.id}>
                        <InfoItemDt>{token.type}</InfoItemDt>
                        <InfoItemDd>{val}</InfoItemDd>
                    </InfoItemList>
                );
            })}
        </Section>
    );
};

export default withTranslation()(Tokens);
